// Plays the brand 16:9 video as an immersive cover background.
// Default video: YouTube Q3wDNNl7crU. Cover-fit on any aspect ratio.
const DEFAULT_YT_ID = "Q3wDNNl7crU";

export function HeroVideo({
  overlay = true,
  children,
  height = "h-[78vh]",
  videoId = DEFAULT_YT_ID,
}) {
  const src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&modestbranding=1&rel=0&playsinline=1`;

  return (
    <div
      className={`relative w-full ${height} overflow-hidden bg-brand-deep-brown grain`}
      data-testid="hero-video"
    >
      {/* Fullscreen 16:9 cover trick:
          width 100vw / height = 56.25vw (16:9 from width)
          min-height 100dvh / min-width = 177.78dvh (16:9 from height)
          The bigger of the two wins per side, so the 16:9 video always
          covers the container with center-crop. */}
      <iframe
        title="ARISTEIA"
        src={src}
        frameBorder="0"
        referrerPolicy="strict-origin-when-cross-origin"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
        style={{
          width: "100vw",
          height: "56.25vw",
          minHeight: "100dvh",
          minWidth: "177.78dvh",
        }}
      />
      {overlay && (
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/35" />
      )}
      <div className="absolute inset-0 z-10 flex flex-col justify-end pointer-events-none">
        <div className="pointer-events-auto">{children}</div>
      </div>
    </div>
  );
}

export default HeroVideo;
